import React from 'react'
import { invoiceStatus } from '@linqpal/models/src/dictionaries'
import { InvoiceListItem } from '../../../ui/atoms/InvoiceListItem'
import { paths } from '../../links'
import { getDisplayAmount } from '../../../utils/helpers/getDisplayAmount'
import { EInvoiceType, InvoicePaymentType } from '@linqpal/models'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { dateMask } from '../../../utils/helpers/masking'

interface Props {
  invoices: any
  navigation: any
  route: any
  setModal?: (a) => void
  isFactoring?: boolean
  disabled?: boolean
  isFromInvitedSupplier?: boolean
}

export const InvoicesListDisplay = ({
  invoices,
  navigation,
  route,
  setModal,
  isFactoring,
  disabled,
  isFromInvitedSupplier = false,
}: Props) => {
  const canViewInvoiceDetails = [
    invoiceStatus.pastDue,
    invoiceStatus.due,
    invoiceStatus.placed,
    invoiceStatus.paymentFailed,
    invoiceStatus.applicationCancelled,
    invoiceStatus.applicationRejected,
    invoiceStatus.pendingDisbursement,
    invoiceStatus.creditApplied,
    invoiceStatus.applicationProcessing,
  ]
  const { t } = useTranslation('global')

  const paidStatuses = [
    invoiceStatus.paid,
    invoiceStatus.collected,
    invoiceStatus.creditApplied,
  ]

  const InvoiceItemOnPress = (invoice) => {
    setModal && setModal(false)
    if (invoice.paymentType === InvoicePaymentType.FACTORING) {
      navigation.navigate(paths.Console.Payables.PaymentHistory, {
        id: invoice._id,
      })
    } else if (paidStatuses.includes(invoice.status)) {
      navigation.navigate(paths.Console.Payables.Receipt, {
        id: invoice._id,
      })
    } else if (
      canViewInvoiceDetails.includes(invoice.status) &&
      !invoice.supplierInvitationDetails?.paymentMethodId && // To check if payment was initiated for an uploaded invoice
      !invoice.totalProcessingAmount
    ) {
      if (isFactoring) {
        navigation.navigate(paths.Console.Payables.Invoice, {
          id: invoice._id,
        })
      } else {
        if (route.name === 'list') {
          navigation.navigate(paths.Console.Payables.Invoice, {
            id: invoice._id,
          })
        } else if (isFromInvitedSupplier) {
          navigation.navigate(paths.Console.Payables.Invoice, {
            id: invoice._id,
          })
        } else {
          navigation.navigate(paths.Console.Payables._self, {
            screen: paths.Console.Payables.Vendor,
            params: { id: invoice._id },
          })
        }
      }
    }
  }

  const formatInvoiceDate = (invoice: any) => {
    if (invoice.type === EInvoiceType.QUOTE) {
      const date = moment(invoice.quoteDetails?.authorization_deadline)
        .tz('America/Chicago')
        .format('MM/DD/YYYY')

      return invoice.quoteDetails?.authorization_deadline
        ? t('Receivables.expires-on', { date })
        : ''
    } else {
      const date = dateMask(invoice.invoice_due_date)
      return t('Receivables.due-on', { date })
    }
  }

  return invoices.map((invoice) => (
    <InvoiceListItem
      key={invoice._id}
      onPress={() => InvoiceItemOnPress(invoice)}
      title={
        invoice.supplierInvitationDetails
          ? invoice.supplierInvitationDetails?.name
          : invoice.company?.name
      }
      subtitle={formatInvoiceDate(invoice)}
      status={invoice.status}
      type={invoice.type}
      disabled={disabled}
      isFactoring={isFactoring}
      amount={getDisplayAmount(invoice.total_amount)}
      style={{ marginBottom: 10 }}
    />
  ))
}
